import { CarePathActivityConditionRestriction } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { Dropdown, FormGroup, FormLabel, InputGroup } from '../../elements/common';

type CarePathActivityConditionProps = {
    label: string;
    onChange: (value: CarePathActivityConditionRestriction | null) => void;
    value: CarePathActivityConditionRestriction | null;
};

export function CarePathActivityCondition({ label, onChange, value }: CarePathActivityConditionProps) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup>
            <FormLabel>{label}</FormLabel>

            <InputGroup>
                <Dropdown
                    onChange={onChange}
                    placeholder={translate.common.notRelevant}
                    selectOptions={[
                        {
                            text: translate.common.yes,
                            value: CarePathActivityConditionRestriction.mustBeTrue,
                        },
                        {
                            text: translate.common.no,
                            value: CarePathActivityConditionRestriction.mustBeFalse,
                        },
                    ]}
                    value={value}
                />
            </InputGroup>
        </FormGroup>
    );
}
